module.exports = __webpack_public_path__ + "media/images/eliminar_verde-68a42fc893a25bf063f9b5237f4bc6e1.svg";